

/**
 * In-memory ICacheStore for the SPA (session-local, no cross-tab sync).
 * Suitable for short-lived list dedupe when navigating back within TTL.
 */

export class MemoryCacheStore {
  constructor() {
    /** @type {Map<string, { value: *, expiresAt: number }>} */
    this.entries = new Map();
  }

  /**
   * @param {string} key
   * @returns {Promise<*|null>}
   */
  async get(key) {
    const entry = this.entries.get(key);
    if (!entry) return null;
    if (Date.now() > entry.expiresAt) {
      this.entries.delete(key);
      return null;
    }
    return entry.value;
  }

  /**
   * @param {string} key
   * @param {*} value
   * @param {number} ttlMs
   */
  async set(key, value, ttlMs) {
    if (!key || value === undefined) return;
    this.entries.set(key, { value, expiresAt: Date.now() + ttlMs });
  }

  /**
   * @param {string} key
   */
  async delete(key) {
    this.entries.delete(key);
  }

  clear() {
    this.entries.clear();
  }
}

/** Process-wide store for campaign list (singleton). */
export const defaultMemoryCacheStore = new MemoryCacheStore();
